/* eslint-disable */ 

import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

import { logoNegative } from 'src/assets/brand/logo-negative'
import { sygnet } from 'src/assets/brand/sygnet'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import { _navFeedback, _nav } from '../_nav'

import { db, auth } from '../firebase'
import { useCollectionData, useDocumentData } from 'react-firebase-hooks/firestore'
import { collection, query, orderBy, addDoc, setDoc, doc } from 'firebase/firestore'

import { useAuthState } from 'react-firebase-hooks/auth'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [user, uloading, uerror] = useAuthState(auth)

  const [UserDoc] = useDocumentData(
        doc(db, 'users', `${user?.uid}`)
      )

  if(user) { //user has to exist or doc cant be referenced properly
    return (
      <CSidebar
        position="fixed"
        unfoldable={unfoldable}
        visible={sidebarShow}
        onVisibleChange={(visible) => {
          dispatch({ type: 'set', sidebarShow: visible })
        }}
      >
        <CSidebarBrand className="d-none d-md-flex" to="/">
          {UserDoc?.nav === 'Feedback' ? <>CWG Feedback</> : null}
          {UserDoc?.nav === 'Helpdesk' ? <>Orian Helpdesk</> : null}
          <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
        </CSidebarBrand>
        <CSidebarNav>
          <SimpleBar>
            {UserDoc?.nav === 'Feedback' ? <AppSidebarNav items={_navFeedback}/> : null}
            {UserDoc?.nav === 'Helpdesk' ? <AppSidebarNav items={_nav} /> : null}
          </SimpleBar>
        </CSidebarNav>
  {/*       <CSidebarToggler
          className="d-none d-lg-flex"
          onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
        /> */}
      </CSidebar>
    )
  }
  return null
}

export default React.memo(AppSidebar)
